export default function createStyles(styles) {
  return styles;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/createStyles/createStyles.js
// module id = 7383
// module chunks = 2